import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import CSVReader from './CsvReader'
import {connect} from 'react-redux'

function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

export function SimpleModal(props) {
  const classes = useStyles();
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = React.useState(getModalStyle);
  const handleOpen = () => {
    props.Set_open_uploader(true);
  };

  const handleClose = () => {
    props.Set_open_uploader(false);
  };

  const body = (
    <div style={modalStyle} className={classes.paper}>
      <h2 id="simple-modal-title">Select a CSV file to upload</h2>
      <CSVReader ReadData={props.ReadData}></CSVReader>
    </div>
  );
  return (
    <div>
      <Modal
        open={props.open_uploader}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body}
      </Modal>
    </div>
  );
}


const maptstateToprop = (state) => {
  return {
    open_uploader:state.open_uploader
  }
}
const mapdispatchToprop = (dispatch) => {
  return {
      Set_open_uploader: (val) => dispatch({ type: "open_uploader", value: val }),
  }
}
export default connect(maptstateToprop, mapdispatchToprop)(SimpleModal);

